import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { approvalTemplatesConfig } from './approvalTemplatesConfig';
import { createApprovalTemplatesValidationSchema } from './approvalTemplatesValidation';

/**
 * Initialize the Approval Templates module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  approvalTemplatesConfig,
  createApprovalTemplatesValidationSchema
);

/**
 * Create the ApprovalTemplatesPage using the generic module page factory
 */
const ApprovalTemplatesPage = createModulePage(
  initializedConfig,
  {
    displayName: 'ApprovalTemplatesPage',
    description: 'Approval Templates Management System - Create and manage approval request templates'
  }
);

export default ApprovalTemplatesPage;

